import { getValidAuthorizationHeader } from '../auth/cognito';
import { getReferralsApiUrl } from '../config/api';
function normalizeNamedValues(values) {
    if (!values)
        return [];
    return values
        .filter((entry) => typeof entry?.value === 'number')
        .map((entry) => ({
        name: entry.name?.trim() || String(entry.value),
        value: entry.value,
    }));
}
function normalizeLookup(raw) {
    return {
        users: raw.users ?? [],
        sites: raw.sites ?? [],
        issueTypes: raw.issueTypes ?? [],
        personKinds: normalizeNamedValues(raw.personKinds),
        personTypes: normalizeNamedValues(raw.personTypes),
        taskRoles: normalizeNamedValues(raw.taskRoles),
        statuses: normalizeNamedValues(raw.statuses),
    };
}
export function namedValueLabel(values, value, fallbackPrefix = 'Value') {
    return values.find((entry) => entry.value === value)?.name ?? `${fallbackPrefix} ${value}`;
}
export async function fetchIncidentLookup() {
    const authorization = await getValidAuthorizationHeader();
    const response = await fetch(getReferralsApiUrl('/referrals/lookup'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: authorization,
        },
        body: JSON.stringify({}),
    });
    const text = await response.text();
    if (!response.ok) {
        throw new Error(`incident lookup failed (${response.status}): ${text.slice(0, 200)}`);
    }
    let payload;
    try {
        payload = JSON.parse(text);
    }
    catch {
        throw new Error(`incident lookup returned non-JSON: ${text.slice(0, 200)}`);
    }
    if (!payload.lookup) {
        throw new Error(payload.error ?? 'incident lookup response missing lookup');
    }
    return normalizeLookup(payload.lookup);
}
let lookupPromise = null;
let cachedLookup = null;
/** Warm Kokomo /api/external/Incidents/lookup via the portal API (caches server-side). */
export function ensureIncidentLookup() {
    if (!lookupPromise) {
        lookupPromise = fetchIncidentLookup()
            .then((lookup) => {
            cachedLookup = lookup;
            return lookup;
        })
            .catch((err) => {
            lookupPromise = null;
            cachedLookup = null;
            throw err;
        });
    }
    return lookupPromise;
}
/** Sync read of the in-memory client cache (null until ensureIncidentLookup resolves). */
export function getCachedIncidentLookup() {
    return cachedLookup;
}
export function clearIncidentLookupClientCache() {
    lookupPromise = null;
    cachedLookup = null;
}
